var _jsxFileName = "/codebuild/output/src1174814487/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/MainContainer/index.tsx";
import React from 'react';
import { VStack } from '@adc/parallax-component-library';
const MainContainer = ({
  ...props
}) => {
  var _CSS, _CSS$supports;
  const isDvhSupported = (_CSS = CSS) === null || _CSS === void 0 || (_CSS$supports = _CSS.supports) === null || _CSS$supports === void 0 ? void 0 : _CSS$supports.call(_CSS, 'height', '1dvh');
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    backgroundColor: "$surface.background",
    justifyContent: "space-between",
    style: [{
      minHeight: '-webkit-fill-available',
      height: isDvhSupported ? '100dvh' : '100vh'
    }]
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }));
};
export { MainContainer };